<div class="form-group" style="display: flex; flex-direction: row; gap: 20px; margin: 20px">
  <div>
    <mat-form-field>
      <mat-label>Tenant Name</mat-label>
      <input matInput type="text"  name="tenant" [(ngModel)]="accessRequest.targetTenant"/>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput type="email"  name="email" [(ngModel)]="accessRequest.targetEmail"/>
    </mat-form-field>
  </div>
  <div>
    <button class="btn btn-secondary" (click)="addRequest()" [disabled]="!accessRequest.targetTenant || !accessRequest.targetEmail">Add</button>
  </div>
</div>

<p-table [value]="accessRequests"
         [rows]="100"
         [style]="{'margin-top':'10px'}"
>
  <ng-template pTemplate="header">
    <tr style="white-space: nowrap;font-weight: bold">
      <th>Tenant</th>
      <th>User</th>
      <th>Status</th>
      <th>Access</th>
      <th>Valid till</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
    <tr>
      <td>{{item.targetTenant}}</td>
      <td>{{item.targetEmail}}</td>
      <td>{{statuses[item.status]}}</td>
      <td><a href="{{item.accessLink}}">{{item.accessLink}}</a></td>
      <td>{{item.accessTimeout}}</td>
    </tr>
  </ng-template>


</p-table>
